const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

class LyleLargeImageBlocks extends HTMLElement {
  #intersectionObserver = null;
  #motionQuery = null;

  connectedCallback() {
    this.#motionQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    this.#motionQuery.addEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );

    this.#initAnimation();
    this.#syncVideoPlayback();
  }

  disconnectedCallback() {
    this.#intersectionObserver?.disconnect();
    this.#intersectionObserver = null;

    this.#motionQuery?.removeEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );
    this.#motionQuery = null;
  }

  #handleMotionPreferenceChange = () => {
    if (this.#motionQuery?.matches) {
      this.classList.add("is-active");
      this.#intersectionObserver?.disconnect();
      this.#intersectionObserver = null;
    }

    this.#syncVideoPlayback();
  };

  #initAnimation() {
    if (this.#motionQuery?.matches || !("IntersectionObserver" in window)) {
      this.classList.add("is-active");
      return;
    }

    this.classList.add("is-observed");

    this.#intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;

        this.classList.add("is-active");
        this.#intersectionObserver?.disconnect();
        this.#intersectionObserver = null;
      },
      { threshold: 0.2 },
    );

    this.#intersectionObserver.observe(this);
  }

  #syncVideoPlayback() {
    const videos = this.querySelectorAll("[data-large-image-blocks-video]");
    const reduceMotion = this.#motionQuery?.matches;

    for (const video of videos) {
      if (reduceMotion) {
        video.pause();
        video.removeAttribute("autoplay");
        continue;
      }

      video.muted = true;
      video.setAttribute("autoplay", "");

      const playPromise = video.play();

      if (playPromise) {
        playPromise.catch(() => {});
      }
    }
  }
}

if (!customElements.get("lyle-large-image-blocks")) {
  customElements.define("lyle-large-image-blocks", LyleLargeImageBlocks);
}
